import React, { useState, useEffect } from 'react';
import { Bell, BellOff } from 'lucide-react';
import OneSignal from 'react-onesignal';

const NotificationToggle: React.FC = () => {
  const [isSubscribed, setIsSubscribed] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    checkSubscriptionStatus();
  }, []);

  const checkSubscriptionStatus = async () => {
    try {
      const subscribed = await OneSignal.User.PushSubscription.optedIn;
      setIsSubscribed(subscribed ?? false);
    } catch (error) {
      console.error('Error checking notification status:', error);
      setIsSubscribed(false);
    }
  };

  const toggleNotifications = async () => {
    setLoading(true);
    try {
      if (isSubscribed) {
        // Opt out of notifications
        await OneSignal.User.PushSubscription.optOut();
        setIsSubscribed(false);
      } else {
        // Opt in to notifications
        await OneSignal.User.PushSubscription.optIn();
        setIsSubscribed(true);
      }
    } catch (error) {
      console.error('Error toggling notifications:', error);
      // If opting in fails, might need to show the prompt
      if (!isSubscribed) {
        OneSignal.Slidedown.promptPush();
      }
    } finally {
      setLoading(false);
      // Recheck status after toggle
      setTimeout(checkSubscriptionStatus, 500);
    }
  };

  // Don't render until we know the status
  if (isSubscribed === null) {
    return null;
  }

  return (
    <button
      onClick={toggleNotifications}
      disabled={loading}
      className="notification-toggle-btn"
      title={isSubscribed ? 'Notifications enabled - Click to disable' : 'Notifications disabled - Click to enable'}
    >
      {isSubscribed ? (
        <Bell size={14} />
      ) : (
        <BellOff size={14} />
      )}
      <span className="notification-toggle-text">{isSubscribed ? 'Alerts On' : 'Alerts Off'}</span>
    </button>
  );
};

export default NotificationToggle;
